import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

// TODO(TLA-9320): rename once the API Gateway is migrated to the new API
@Injectable({
  providedIn: 'root',
})
export class NotificationNewEndpointService {
  readonly #service = inject(ServicesService);

  getNotificationsForMethod(methodSlug: string) {
    return this.#service.userService(`notifications/method/${methodSlug}`);
  }

  getNotificationSeen(notificationId: string) {
    return this.#service.userService(`notifications/${notificationId}/seen`);
  }

  getNotificationAllSeen(methodSlug: string) {
    return this.#service.userService(`notifications/method/${methodSlug}/seen`);
  }

  getnotificationDelete(notificationId: string) {
    return this.#service.userService(`notifications/${notificationId}`);
  }
}
